// utils/HTMLReportGenerator/HTMLReportGenerator.js

import { ReportHeader } from "./ReportHeader.js";
import { ReportFilters } from "./ReportFilters.js";
import { ReportTreeView } from "./ReportTreeView.js";
import { ReportStyles } from "./ReportStyles.js";
import { ReportUtils } from "./ReportUtils.js";

export class HTMLReportGenerator {
  /**
   * Générer le rapport HTML complet
   * @param {Object} results - Résultats des tests
   * @param {Array} fibers - Liste des fibres testées
   * @returns {string} HTML complet du rapport
   */
  static generate(results, fibers) {
    const timestamp = new Date().toLocaleString("fr-FR");
    const hierarchy = ReportUtils.buildFiberHierarchy(fibers);

    return this.buildCompleteHTML(timestamp, results, hierarchy);
  }

  /**
   * Construire le HTML complet du rapport
   */
  static buildCompleteHTML(timestamp, results, hierarchy) {
    return `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Rapport validation PM - ${timestamp}</title>
    <style>${ReportStyles.generateStyles()}</style>
    <script>
      ${ReportTreeView.generateTreeViewJS()}
      ${ReportFilters.generateFilterJS()}
    </script>
</head>
<body>
    <div class="container">
        ${ReportHeader.generateHeader(timestamp)}
        ${ReportHeader.generateSummary(results)}
        ${ReportTreeView.generateHierarchy(hierarchy)}
        ${ReportHeader.generateFooter()}
    </div>
</body>
</html>
    `;
  }
}
